import { render, staticRenderFns } from "./SupplierMapping.vue?vue&type=template&id=4aa24482&scoped=true"
import script from "./SupplierMapping.vue?vue&type=script&lang=js"
export * from "./SupplierMapping.vue?vue&type=script&lang=js"
import style0 from "./SupplierMapping.vue?vue&type=style&index=0&id=4aa24482&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa24482",
  null
  
)

export default component.exports